import { render, staticRenderFns } from "./TransMoveListDialog.vue?vue&type=template&id=4561a5f7&scoped=true"
import script from "./TransMoveListDialog.vue?vue&type=script&lang=js"
export * from "./TransMoveListDialog.vue?vue&type=script&lang=js"
import style0 from "./TransMoveListDialog.vue?vue&type=style&index=0&id=4561a5f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561a5f7",
  null
  
)

export default component.exports